import type { DefaultAbilityGrant, DefaultAbilityGrantsInput } from '../types';

const KNOCKOUT = '94D415AD-FE22-4688-A875-A2439BEFECA9';
const OVERRUN = '1DC3B3DE-BD4C-B77A-429D-12C7F2B2439D';
const EVADE = 'BE4CCA95-33F0-323D-BA54-844D2540C0F0';
const RESOLVE = 'B2BC3219-C745-7050-51DD-892951F0026B';
const DODGE = '62323E36-5B5E-0114-2750-ED864773B062';
const LEGENDARY = '8BA69C40-9191-8AF6-D521-5BF6A31F989E';

const grant = (layer: string, abilityId: string, itemName: string, hidden: boolean): DefaultAbilityGrant => ({
    layer,
    abilityId,
    itemName,
    source: abilityId,
    requiresLevel: 0,
    hidden,
});

/** Select the normalized universal/legendary grants added before ability finalization. */
export function compileDefaultAbilityGrants(input: DefaultAbilityGrantsInput): DefaultAbilityGrant[] {
    const grants: DefaultAbilityGrant[] = [];
    if (input.hasEncounterCreatureId && input.itemType !== 'lair') {
        grants.push(
            grant('attack_ability', KNOCKOUT, 'Knockout Strike', false),
            grant('free_ability', OVERRUN, 'Overrun', true),
            grant('reaction_ability', EVADE, 'Evade', true),
            grant('reaction_ability', RESOLVE, 'Resolve', true),
            grant('ability', DODGE, 'Dodge', true),
        );
        if (input.legendaryCreature) grants.push(grant('ability', LEGENDARY, 'Legendary Defenses', false));
    } else if (input.legendaryCreature && !input.hasEncounterCreatureId) {
        grants.push(grant('ability', LEGENDARY, 'Legendary Defenses', false));
    }
    return grants;
}
